import { render, staticRenderFns } from "./MapAttribution.vue?vue&type=template&id=54022cce&scoped=true&"
import script from "./MapAttribution.vue?vue&type=script&lang=js&"
export * from "./MapAttribution.vue?vue&type=script&lang=js&"
import style0 from "./MapAttribution.vue?vue&type=style&index=0&id=54022cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54022cce",
  null
  
)

export default component.exports